<template lang="pug">
    .map-box-key(v-if="k >= 0")
        h4
            i.el-icon-fa-map-marker-alt.fas
            | {{ $t('Mapbox') }}
        el-form-item(:label="$t('Token')")
            el-input(type="input" v-model="public" maxlength="255" show-word-limit)
</template>

<i18n>
{
    "de": {
        "Mapbox": "Mapbox",
        "Token": "Token"
    }
}
</i18n>

<script>
import _ from 'lodash'
import { useSettingsStore, useCmsWizardStore } from '@/stores'

export default {
    name: 'MapBoxKey',
    props: {
        cms: {
            type: Object,
            required: true,
        },
        storeModule: {
            type: String,
            default: 'settings/form',
        },
    },
    data() {
        return {
            key: 'mapbox',
        }
    },
    computed: {
        isWizardMode() {
            return this.storeModule === 'cmsWizard';
        },
        k() {
            const apiKeys = _.get(this.cms, 'apiKeys') || []
            return _.findIndex(apiKeys, apiKey => apiKey.key === this.key)
        },
        public: {
            get() {
                return _.get(this.cms, `apiKeys.${this.k}.public`, '')
            },
            set(value) {
                const data = {
                    index: this.k,
                    field: 'public',
                    value
                }
                if (this.isWizardMode) {
                    useCmsWizardStore().cmsApiKey(data);
                } else {
                    useSettingsStore().setFormCmsApiKey(data);
                }
            }
        },
    },
    mounted() {
        if (this.k < 0) {
            if (this.isWizardMode) {
                useCmsWizardStore().addCmsApiKey(this.key);
            } else {
                useSettingsStore().addFormCmsApiKey(this.key);
            }
        }
    }
}
</script>

<style lang="sass" scoped>
    .map-box-key
        padding-left: 12px
        position: relative
        &:before
            content: ''
            position: absolute
            left: 0
            top: 0
            bottom: 0
            width: 4px
            background: rgba($color-grey-text, .2)
            border-radius: 6px
        h4
            color: $color-grey-text
</style>
